import Provider from "./Provider";

import ProviderOverview from "./overview/Overview";
import ProviderResponses from "./response/Responses";

export default [
  {
    path: "",
    component: Provider,

    children: [
      {
        component: ProviderOverview,
        path: "",
        name: "provider",

        // For navigation display
        id: "overview",
        icon: "overview",
        text: "Overview",
      },
    ],
  },
];
